<template>
  <div class="hello">
    <div class="subTitle">广元天立小初</div>
    <div class="payButton">
      <van-button
          v-for="item in payButtons"
          :key="item.label"
          round
          block
          size="large"
          icon="bill-o"
          :color="buttonGradient"
          class="pay-btn"
          @click="goTo(item.url)"
      >
        {{ item.label }}
      </van-button>
    </div>
  </div>
</template>


<script>
export default {
  name: 'gytlxc',
  data() {
    return {
      // 按钮配置数组（可维护性强）
      payButtons: [
        {
          label: '学费',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM61dlTiX0c2Z5+CNnzVnU0Rq30Ga1rueFBmrqM015qjdumjof3GBfAXvBaokT5gyttouoKxx5o7G+nZ2qAY9zmXGgVcfbfdceEwZMxGVq4qR3k9mXhoE6dTQJUTSxBXFvzVYz6tsvNIoGtwUm3Q0vRU='
        },
        {
          label: '餐费',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM1CNkbJN3tfRK2GZ28l5ZalXkMuWCbuSxub8xMoQ4mtcEcGKZl9ilO6FGCZhR5irnyAQGzWcO3d6/zY+o7fpCnc7AZZxQkidjjsQ8+zOe2aJWy8SIsiJTDw3F111BgnrIBfOgozhgQQwRv669nUtOLg='
        },
        {
          label: '素养服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmM3b2ES8Zqti/Y74dvb/O585oeKTHrRztFi9CQfwro0N+jsHhLEPnp08EHJu0QBfz7+UUhyvzAePWJ5Focvm+puMAlvGkY/n5rbb4icjqWKsttL38BnZpsP6XP8CHzSm/qcweohlKd1t/155cG58PHP4y1vF/1KQkEn66jGEq/YJi'
        },
        {
          label: '综合服务',
          url: 'https://common-cspay.cibfintech.com/?data=KoJTj55Y6Vd8f37edaf21f4373Vg5oDmh4XmMzjhohV7xafHmHtZTEA9Z8CfyGfO1PplN6gkIH5lgsNUd0wI0hoTGRwG0VSbx9DC7vWagtVl+YMKTseTeExOJQ6NxFYt4Jo+xOKhxcpfJqG1IC8Uu7/jKe9DYqrvGk71twpsOPbfcoPTRDuIE8iL9zA='
        }
      ],
      buttonGradient: 'linear-gradient(to right, #0055ff, #00aaff)',
    };
  },
  created() {
    document.title = '广元天立小初';
  },
  methods: {
    goTo(url) {
      window.location.href = url;
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.subTitle {
  margin-top: 10px;
  font-size: 28px;
  padding-bottom: 16px;
  text-align: center;
}

.payButton {
  margin: 20px auto;
  width: 75vw;
}

.pay-btn {
  margin-bottom: 16px; /* 替代 br 和 div 高度 */
}
</style>

